import { FC, ReactElement } from 'react'
import cx from 'classnames'
import * as RadioGroup from '@radix-ui/react-radio-group'

export interface RadioItem {
  value: string | number
  label: string
  component?: ReactElement
}

type RadioFilterProps = {
  items: RadioItem[]
  selectedValue: string | number
  onValueChange: (value: string) => void
  className?: string
  ariaLabelledBy?: string
}

const RadioFilter: FC<RadioFilterProps> = ({
  items,
  selectedValue,
  onValueChange,
  className,
  ariaLabelledBy,
}) => {
  return (
    <RadioGroup.Root
      value={selectedValue.toString()}
      onValueChange={(value) => onValueChange(value)}
      className={className}
      aria-labelledby={ariaLabelledBy}
    >
      {items.map(({ value, label, component }, i) => {
        const isFirst = i === 0
        const isLast = i === items.length - 1
        const isActive = value === selectedValue
        return (
          <RadioGroup.Item
            key={value}
            value={value.toString()}
            className={cx('border p-12 text-14 font-semibold', {
              'rounded-l-sm': isFirst,
              'rounded-r-sm': isLast,
              'border-teal-3 bg-teal-3 text-white': isActive,
              'border-grey-3 bg-grey-2 text-teal-3': !isActive,
            })}
          >
            <RadioGroup.Indicator />
            {component ? component : label}
          </RadioGroup.Item>
        )
      })}
    </RadioGroup.Root>
  )
}

export default RadioFilter
